import axios from 'axios'
import store from '@/store'
import config from './config'
import { Message, MessageBox } from 'element-ui'
import { getToken } from '@/helpers/auth'

export default function $axios(options) {
  return new Promise((resolve, reject) => {
    const instance = axios.create({
      baseURL: config.baseURL,
      timeout: config.timeout,
      headers: {
        // 'Ocp-Apim-Subscription-Key': process.env.VUE_APP_APIM_KEY,
        // 'Ocp-Apim-Trace': 'true'
      }
    })

    // request 拦截器
    instance.interceptors.request.use(
      config => {
        // 登录：process.env.VUE_APP_TOKEN； 其他：登录给到的token
        // config.headers['token'] = getToken()

        return config
      },
      error => {
        Message({
          message: '请求超时',
          type: 'error',
          duration: 1.5 * 1000
        })
        return Promise.reject(error) // 在调用的那边可以拿到(catch)你想返回的错误信息
      }
    )

    // response 拦截器
    instance.interceptors.response.use(
      response => {
        // console.log(response)
        const res = response.data

        return res
      },
      err => {
        console.log('err' + JSON.stringify(err))

        if (axios.isCancel(err)) {
          return Promise.reject(err)
        }

        if (err && err.response) {
          switch (err.response.status) {
            case 400:
              err.message = '请求错误'
              break

            case 401:
              err.message = '未授权，请登录'
              break

            case 403:
              err.message = '拒绝访问'
              break

            case 404:
              err.message = `请求地址出错: ${err.response.config.url}`
              break

            case 408:
              err.message = '请求超时'
              break

            case 500:
              err.message = '服务器内部错误'
              break

            case 501:
              err.message = '服务未实现'
              break

            case 502:
              err.message = '网络错误'
              break

            case 503:
              err.message = '服务不可用'
              break

            case 504:
              err.message = '网络超时'
              break

            case 505:
              err.message = 'HTTP版本不受支持'
              break

            default:
          }
        }

        // 超时
        if (err.code === 'ECONNABORTED' && err.message.indexOf('timeout') !== -1) {
          err.errorCode = '000'
          err.message = '连接超时，请重新尝试'
        }

        Message({
          message: err.message,
          type: 'error',
          duration: 1.5 * 1000
        })

        return Promise.reject(err) // 返回接口返回的错误信息
      }
    )

    // 请求处理
    instance(options)
      .then(res => {
        resolve(res)
        return false
      })
      .catch(error => {
        reject(error)
      })
  })
}
